import { useQuery } from "@tanstack/react-query";
import { acceptanceDocuments } from "@fm/api";
import type { ApiClient } from "@fm/api";
import type { AcceptanceDocument } from "@fm/api";
import { getApiBaseUrl } from "../lib/config";

export interface UseAcceptanceDocumentsOptions {
  apiKey: string;
  vehicleId: string;
  apiBaseUrl?: string;
  enabled?: boolean;
}

/**
 * Hook to fetch a vehicle's mandatory (checkbox) documents — the ones the
 * customer must accept before checkout can continue (fleet-agreement-
 * acceptance, path 1).
 */
export function useAcceptanceDocuments(options: UseAcceptanceDocumentsOptions) {
  const { apiKey, vehicleId, apiBaseUrl, enabled = true } = options;

  const apiClient: ApiClient = {
    baseUrl: getApiBaseUrl(apiBaseUrl),
    apiKey,
  };

  return useQuery<AcceptanceDocument[], Error>({
    queryKey: ["acceptance-documents", vehicleId],
    queryFn: async () => {
      const response = await acceptanceDocuments.list(apiClient, vehicleId);
      return response.data;
    },
    enabled: enabled && !!vehicleId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
